import React, {useMemo} from "react";
import {DeviceFrameset} from 'react-device-frameset';
import classnames from "classnames";

const deviceOptions = {
    "iPhone X": {
        device: "iphone-x",
        colors: [],
        hasLandscape: true,
    },
    "iPhone 8": {
        device: "iphone8",
        colors: ["black", "silver", "gold"],
        hasLandscape: true,


    },
    "iPhone 8 Plus": {
        device: "iphone8plus",
        colors: ["black", "silver", "gold"],
        hasLandscape: true,


    },
    "iPhone 5s": {
        device: "iphone5s",
        colors: ["black", "silver", "gold"],
        hasLandscape: true,
    },
    "iPhone 5c": {
        device: "iphone5c",
        colors: ["white", "red", "yellow", "green", "blue"],
        hasLandscape: true,
    },
    "iPhone 4s": {
        device: "iphone4s",
        colors: ["black", "silver"],
        hasLandscape: true,
    },
    "Galaxy Note 8": {
        device: "note8",
        colors: [],
        hasLandscape: true,
    },
    "Nexus 5": {
        device: "nexus5",
        colors: [],
        hasLandscape: true,
    },
    "Lumia 920": {
        device: "lumia920",
        colors: ["black", "white", "yellow", "red", "blue"],
        hasLandscape: true,
    },
    "Samsung Galaxy S5": {
        device: "s5",
        colors: ["white", "black"],
        hasLandscape: true,
    },
    "HTC One": {
        device: "nexus5",
        colors: [],
        hasLandscape: true,
    },
    "iPad Mini": {
        device: "ipad",
        colors: ["black", "silver"],
        hasLandscape: true,
    },
    "MacBook Pro": {
        device: "macbook",
        colors: [],
        hasLandscape: false,
    },
}

/**
 * @param {any} children
 * @param {string} deviceProps
 * @param {string} color
 * @param {Partial<import("react-device-frameset").DeviceFramesetProps>} props
 * @return {JSX.Element}
 * @constructor
 */
const DeviceSimulator = ({children, color, device: deviceProps, ...props}) => {
    const deviceOption = useMemo(() => deviceOptions[deviceProps ?? 'iPhone X'], [deviceProps])
    const device = useMemo(() => deviceOption?.device ?? 'iphone-x', [deviceOption])

    return (
        <>
            <DeviceFrameset
                {...props}
                device={deviceProps}
                color={color}
                className={classnames(props.className, 'marvel-device', {
                    [color]: !!color,
                    [device]: !!device,
                })}
            >
                {children}
            </DeviceFrameset>
        </>
    )
}

export default DeviceSimulator;
